<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <i
          class="bx bxs-left-arrow"
          style="float: left; font-size: 1.5rem"
          onclick="history.back()"
        ></i>

        <h5 class="text-center">
          {{ selectedIncident.category_name }} Details
        </h5>
        <hr />

        <div class="table-responsive">
          <table class="table mb-0">
            <tbody>
              <tr>
                <th scope="row">{{ selectedIncident.category_name }} Id</th>
                <td>{{ selectedIncident.id }}</td>
              </tr>
              <tr>
                <th scope="row">
                  {{ selectedIncident.category_name }} Category
                </th>
                <td>{{ selectedIncident.category_name }}</td>
              </tr>
              <tr>
                <th scope="row">{{ selectedIncident.category_name }} Source</th>
                <td>{{ selectedIncident.source_name }}</td>
              </tr>
              <tr>
                <th scope="row">Chainage Number</th>
                <td>{{ selectedIncident.ch_no }}</td>
              </tr>
              <tr>
                <th scope="row">Side</th>
                <td>{{ selectedIncident.side_name }}</td>
              </tr>
              <tr v-if="selectedIncident.category_name === 'Incident'">
                <th scope="row">Vehicle Number</th>
                <td>{{ selectedIncident.vehicle_no }}</td>
              </tr>
              <tr v-if="selectedIncident.category_name === 'Incident'">
                <th scope="row">Vehicle Class</th>
                <td>{{ vehicleClassName }}</td>
              </tr>
              <tr v-if="selectedIncident.category_name === 'Accident'">
                <th scope="row">Nature of Accident</th>
                <td>{{ selectedIncident.nature_of_accident }}</td>
              </tr>
              <tr v-if="selectedIncident.category_name === 'Accident'">
                <th scope="row">Nature of Injury</th>
                <td>{{ selectedIncident.nature_of_injury }}</td>
              </tr>
              <tr v-if="selectedIncident.category_name === 'Accident'">
                <th scope="row">Name of Hospital</th>
                <td>{{ selectedIncident.hospital_name }}</td>
              </tr>
              <tr v-if="selectedIncident.category_name === 'Accident'">
                <th scope="row">MBCB</th>
                <td>{{ selectedIncident.mbcb }}</td>
              </tr>
              <tr v-if="selectedIncident.category_name === 'Accident'">
                <th scope="row">Hydra Time</th>
                <td>{{ selectedIncident.hydra_time }}</td>
              </tr>
              <tr>
                <th scope="row">Description</th>
                <td>{{ selectedIncident.description }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="mt-5" v-if="selectedIncident.category_name === 'Accident'">
          <h4 class="card-title">Vehicle Details</h4>
        </div>
        <hr />
        <div class="row" v-if="selectedIncident.category_name === 'Accident'">
          <div class="col-12">
            <div class="mb-3">
              <b-table-lite :items="items" :fields="vehicleFields">
                <template #cell(actions)="row">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="m-1"
                    @click="editVehicleDetails(row.item)"
                    >View
                  </b-button>
                </template>
              </b-table-lite>
            </div>
          </div>
        </div>

        <!-- Image Upload -->
        <div class="row">
          <div class="col-12">
            <h4 class="card-title">
              {{ selectedIncident.category_name }} Photos
            </h4>
            <hr />

            <img
              v-for="(src, index) in incidentImages"
              :key="index"
              class="float-left image"
              @click="() => showCaptiomImg(index)"
              width="150"
              :src="src"
              style="margin-right: 10px; cursor: pointer"
            />
          </div>
          <vue-easy-lightbox
            :visible="visibleCaption"
            :imgs="incidentImages"
            :index="index"
            @hide="handleCaptionHide"
          ></vue-easy-lightbox>
        </div>
      </div>

      <!-- view vehicle details -->
      <b-modal
        id="view-vehicle-details-modal"
        title="Vehicle Details"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
      >
        <template #modal-header>
          <div><h5>Accident Vehicle</h5></div>
          <div>
            <button
              class="btn btn-sm btn-outline-danger"
              @click="$bvModal.hide('view-vehicle-details-modal')"
            >
              Cancel
            </button>
          </div>
        </template>

        <div class="card">
          <div class="card-body">
            <div class="table-responsive">
              <table class="table mb-0">
                <tbody>
                  <tr>
                    <th scope="row">Driver Name</th>
                    <td>{{ selectedVehicle.driver_name }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Vehicle No.</th>
                    <td>{{ selectedVehicle.vehicle_no }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Mobile No.</th>
                    <td>{{ selectedVehicle.mobile_no }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Driver Address</th>
                    <td>{{ selectedVehicle.driver_address }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Origin of Vehicle</th>
                    <td>{{ selectedVehicle.origin }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Point of Arrival</th>
                    <td>{{ selectedVehicle.arrival }}</td>
                  </tr>
                  <tr>
                    <th scope="row">Destination of Vehicle</th>
                    <td>{{ selectedVehicle.destination }}</td>
                  </tr>
                  <tr>
                    <th scope="row">No. of Passengers</th>
                    <td>{{ selectedVehicle.passenger_count }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
  </Layout>
</template>

<script>
import incidentMixin from "@/mixins/incident";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import Layout from "@/layouts/main";

// Create component
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

import appConfig from "@/app.config";
import Swal from "sweetalert2";

export default {
  mixins: [incidentMixin],

  page: {
    title: "Report Incident",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    FilePond,
    Layout,
  },
  data() {
    return {
      incidentCategoryId: null,
      subCategoryId: null,
      incidentSourceId: null,
      incidentDescription: null,
      chainageNo: null,
      sideId: null,
      injuredCount: null,
      incidentDate: null,
      incidentTime: null,
      informedTo: null,
      credits: "",
      userRole: null,
      challanStatusId: null,
      selectedIncident: {},
      incident_id: null,
      driver_name: null,
      vehicle_no: null,
      vehicleClassName: null,
      mobile_no: null,
      driver_address: null,
      origin_of_vehicle: null,
      point_of_arrival: null,
      destination_of_vehicle: null,
      no_of_passengers: null,
      visibleCaption: false,
      index: 1,

      addVehicleDetailsObj: {},
      selectedIncidentDetailsObj: {},
      selectedVehicle: {},
      options: {
        incidentCategory: [],
        subCategory: [],
        incidentSource: [],
        side: [],
        informedTo: [],
        vehicleClass: [],
      },

      items: [],

      vehicleFields: [
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],

      fields: [
        {
          key: "vehicle_no",
          label: "Vehicle No.",
          sortable: false,
        },
        {
          key: "driver_name",
          label: "Driver Name",
          sortable: true,
        },
        {
          key: "actions",
        },
      ],

      image: "",
      file: "",
      myFiles: [],
    };
  },

  watch: {
    incidentCategoryId: function () {
      if (this.incidentCategoryId == 1) this.subCategoryId = null;
    },
  },

  computed: {
    incidentImages() {
      return this.selectedIncident.images
        ? this.selectedIncident.images.map((e) => e.media_url)
        : [];
    },
  },

  methods: {
    addVehicleDetails() {
      this.$bvModal.show("add-vehicle-details-modal");
    },

    showCaptiomImg(index) {
      this.index = index;
      this.visibleCaption = true;
    },

    handleCaptionHide() {
      this.visibleCaption = false;
    },

    async submitVehicleDetails() {
      try {
        this.addVehicleDetailsObj.incident_id = this.selectedIncident.id;
        this.AddVehicleDetails(this.addVehicleDetailsObj);
        Swal.fire(
          "Saved!",
          "Vehicle details saved successfully",
          "success"
        ).then(async () => {
          this.$bvModal.hide("add-vehicle-details-modal");
          this.addVehicleDetailsObj = {};
          await this.showVehicles(this.selectedIncident.id);
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to create VSDS", "error");
      }
    },

    deleteVehicleDetails(id) {
      try {
        const body = {
          id: id,
        };
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
        }).then(async (result) => {
          if (result.isConfirmed) {
            Swal.fire("Deleted!", "Your file has been deleted.", "success");
            await this.DeleteVehicleDetails(body);
            await this.showVehicles(this.selectedIncident.id);
          }
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to delete VSDS", "error");
      }
    },

    async reportIncident() {
      try {
        this.ReportIncident(this.selectedIncidentDetailsObj);
        Swal.fire("Saved!", "Report saved successfully", "success").then(() => {
          this.$router.push("/phone/incidents");
        });
      } catch (e) {
        Swal.fire("Failed!", "Failed to create VSDS", "error");
      }
    },

    editVehicleDetails(vehicle) {
      this.selectedVehicle = vehicle;
      this.$bvModal.show("view-vehicle-details-modal");
    },

    async getIncidentMasters() {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.incidentCategory = incidents.getIncidentCategory;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.incidentSource = incidents.getIncidentSource;
        this.options.side = incidents.getIncidentSide;
        this.options.informedTo = incidents.rpoData;
        this.options.vehicleClass = incidents.getVehicleClass;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async saveIncidentImages(incidentId) {
      try {
        this.$store.dispatch("layout/changeLoaderValue", true);
        if (this.$refs.pond) {
          const files = this.$refs.pond.getFiles();
          for (let file of files) {
            let formData = new FormData();
            formData.append("photo", file.file);
            formData.append("id", incidentId);
          }
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        this.$store.dispatch("layout/changeLoaderValue", false);
        Swal.fire("Error Occurred", e.response.data.message, "error");
        this.clearData();
      }
    },

    getUsers() {
      this.userRole = this.$store.getters["auth/user"].user.role;
    },

    clearData() {
      this.incidentCategoryId = null;
      this.subCategoryId = null;
      this.incidentSourceId = null;
      this.incidentDescription = null;
      this.chainageNo = null;
      this.sideId = null;
      this.vehicleNumber = null;
      this.incidentDate = null;
      this.incidentTime = null;
      this.informedTo = null;

      if (this.$refs.pond) {
        this.$refs.pond.removeFiles();
      }

      this.$emit("closeModal");
    },

    async showVehicles(id) {
      const body = {
        id: id,
      };
      this.items = await this.ShowVehicleDetails(body);
    },

    formatDate(d) {
      const date = new Date(d);
      let day = date.getDate();
      let month = date.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    findVehicleClass() {
      const className = this.options.vehicleClass.filter(
        (className) => className.id === this.selectedIncident.vehicle_class_id
      );
      this.vehicleClassName = className[0].class_name;
    },
  },
  async mounted() {
    this.$store.dispatch("layout/changeLoaderValue", true);
    await this.getIncidentMasters();
    this.$store.dispatch("layout/changeLoaderValue", false);
    this.getUsers();
    this.informedTo = this.$store.getters["auth/user"].user.first_name;
    this.findVehicleClass();
  },

  created() {
    this.selectedIncident = this.$route.params.data;
    this.showVehicles(this.selectedIncident.id);
  },
};
</script>
<style>
.filepond--root {
  font-family: "Poppins", sans-serif;
}

.filepond--panel-root {
  background-color: #2a3042;
}

.filepond--drop-label {
  color: #a6b0cf;
  font-size: 10px;
}

textarea::placeholder,
input::placeholder {
  color: #717174 !important;
}

.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__selected,
.vs__dropdown-menu {
  background: #2a3042;
  border: none;
  color: #a6b0cf;
  font-size: 13px;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected .vs--disabled::placeholder {
  background-color: #1a2031;
  color: #1a2031;
}

.vs__disabled-bg {
  background: #333f78;
}

.vs__clear,
.vs__open-indicator {
  fill: #394066;
}

@media (min-width: 30em) {
  .filepond--item {
    width: calc(50% - 0.5em);
  }
}

@media (min-width: 50em) {
  .filepond--item {
    width: calc(16.66% - 0.5em);
  }
}

.footer-raise-btn {
  position: fixed;
  bottom: 80px;
  width: 97%;
}
</style>
